{
  "en": {
    "filteredList": {
      "actions": {
        "showFilter": "Show Filters",
        "hideFilter": "Hide Filters"
      },
      "selected": "Selected filters",
      "remove": "Remove %{filter}",
      "more": "+%{count} more",
      "groups": {
        "ship": "Ship",
        "capacity": "Capacity & dimensions",
        "weapons": "Weapons",
        "price": "Price",
        "ownership": "Ownership"
      }
    }
  }
}
